$(".flex_col").on('click', function(event){
  event.stopPropagation();
  event.stopImmediatePropagation();
  if($('body').attr('class') == 'theme-omdia'){
    $(this).find('.click-utag')[0].click();
  }
});
